export default {
  header: {
    home: 'Inicio',
    translateName: 'Traducir Nombre',
    customName: 'Nombre Personalizado',
    multilingualName: 'Nombre Multilingüe',
    knowledgeBase: 'Base de Conocimiento',
    login: 'Iniciar Sesión',
    signup: 'Registrarse',
    siteName: 'ChineseName.us'
  },
  footer: {
    aboutUs: 'Sobre Nosotros',
    contact: 'Contacto',
    privacy: 'Política de Privacidad',
    terms: 'Términos de Servicio',
    copyright: '© 2023 ChineseName.us. Todos los derechos reservados.'
  },
  home: {
    hero: {
      title: 'Descubre Tu Nombre Chino Perfecto',
      subtitle: 'Traducción y creación de nombres con significado cultural',
      cta: 'Comenzar'
    },
    features: {
      title: 'Nuestros Servicios',
      translateName: {
        title: 'Traduce Tu Nombre',
        description: 'Convierte tu nombre a chino con pronunciación y significado precisos'
      },
      customName: {
        title: 'Nombre Chino Personalizado',
        description: 'Obtén un nombre chino personalizado basado en tus preferencias y personalidad'
      },
      multilingualName: {
        title: 'Nombres Multilingües',
        description: 'Traduce tu nombre a varios idiomas, incluyendo chino, japonés y más'
      },
      knowledge: {
        title: 'Conocimiento sobre Nombres Chinos',
        description: 'Aprende sobre tradiciones de nombres chinos, nombres populares y significado cultural'
      }
    },
    about: {
      title: 'Por qué los Nombres Chinos son Importantes',
      description: 'Un nombre chino bien elegido puede abrir puertas en negocios, educación e intercambio cultural. Muestra respeto por la tradición y ayuda a crear conexiones significativas.'
    }
  },
  common: {
    loading: 'Cargando...',
    error: 'Ocurrió un error',
    retry: 'Reintentar',
    share: 'Compartir',
    save: 'Guardar',
    copy: 'Copiar',
    copied: '¡Copiado!',
    required: 'Campo requerido',
    optional: 'Opcional',
    search: 'Buscar',
    noResults: 'No se encontraron resultados'
  },
  characterStrokes: {
    title: 'Orden de Trazos de Caracteres Chinos',
    subtitle: 'Ver el orden de trazos y la pronunciación de los caracteres chinos, aprenda el método correcto de escritura',
    inputTitle: 'Ingrese un Carácter para Buscar',
    inputPlaceholder: 'Ingrese un carácter',
    inputHint: 'Por favor ingrese un carácter chino, ej.: 爱, 德, 福',
    popularCharacters: 'Caracteres Comunes',
    loading: 'Obteniendo información del carácter...',
    pinyin: 'Pinyin',
    strokeCount: 'Cantidad de Trazos',
    radical: 'Radical',
    meaning: 'Significado',
    strokeOrder: 'Orden de Trazos',
    demoAnimation: 'Demostración Animada',
    strokeDetails: 'Detalles de Trazos',
    basicStrokes: 'Trazos Básicos',
    strokeSequence: 'Secuencia de Trazos del Carácter',
    noSequenceData: 'No hay datos detallados de secuencia de trazos disponibles',
    relatedCharacters: 'Caracteres Relacionados',
    noRelatedData: 'No hay datos de caracteres relacionados disponibles',
    errorTitle: 'Error de Búsqueda',
    noData: 'No hay datos disponibles'
  }
} 